export const DiscountApplicationStatus = {
  Undefined: 0,
  Applicable: 1,
  NotFound: 2,
  Expired: 3,
  NotYetActive: 4,
  NotApplicable: 5,
};